module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-badge"
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('sup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden && (_vm.content || _vm.isDot)),
      expression: "!hidden && (content || isDot)"
    }],
    staticClass: "el-badge-content",
    class: {
      'is-fixed': _vm.$slots.default, 'is-dot': _vm.isDot
    },
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44db8e67!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/badge/src/main.vue
// module id = 641
// module chunks = 0